module.exports = __webpack_public_path__ + "media/images/reg_1_redesign_reason_sprites-6073fdee.png";